export default "/assets/images/favicon-192x192.png?b1dc0ffba4353c1a96e8910a464ab2ec";